import { PRICE_PLAN_BUTTON_LABELS } from "@/constants/pricePlanButtonLabels";
import { User, UserNoDates } from "@/types/types";
import { getChangeSubscriptionPlanStatus } from "@/utils/subscriptionLevels/getChangeSubscriptionPlanStatus";

export const getSubscriptionButtonLabel = ({
  loggedIn,
  stripeSubscriptionId,
  user,
}: {
  loggedIn: boolean;
  stripeSubscriptionId: User["stripeSubscriptionId"];
  user: UserNoDates | null;
}): (typeof PRICE_PLAN_BUTTON_LABELS)[keyof typeof PRICE_PLAN_BUTTON_LABELS] => {
  if (!loggedIn) {
    return stripeSubscriptionId === null ?
        PRICE_PLAN_BUTTON_LABELS.GET_STARTED
      : PRICE_PLAN_BUTTON_LABELS.GET_PLAN;
  }

  if (stripeSubscriptionId === null) {
    return PRICE_PLAN_BUTTON_LABELS.GET_STARTED;
  }

  if (user === null || user.stripeSubscriptionId === null) {
    return PRICE_PLAN_BUTTON_LABELS.GET_PLAN;
  }

  const upgradeDowngradeSame = getChangeSubscriptionPlanStatus(
    user.stripeSubscriptionId,
    stripeSubscriptionId
  );

  if (upgradeDowngradeSame === null) {
    return PRICE_PLAN_BUTTON_LABELS.GET_PLAN;
  }

  if (upgradeDowngradeSame === "upgrade") {
    return PRICE_PLAN_BUTTON_LABELS.UPGRADE;
  }

  if (upgradeDowngradeSame === "downgrade") {
    return PRICE_PLAN_BUTTON_LABELS.DOWNGRADE;
  }

  if (upgradeDowngradeSame === "goYearly") {
    return PRICE_PLAN_BUTTON_LABELS.GO_YEARLY;
  }

  if (upgradeDowngradeSame === "goMonthly") {
    return PRICE_PLAN_BUTTON_LABELS.GO_MONTHLY;
  }

  return user.stripeSubscriptionCancelAtPeriodEnd ?
      PRICE_PLAN_BUTTON_LABELS.RENEW
    : PRICE_PLAN_BUTTON_LABELS.MANAGE;
};
